import React from "react";
import TableCell, { SortDirection } from "@mui/material/TableCell";
import "./styles.scss";

const classNameBase = "scd-table-cell";

interface CellProps {
  children: React.JSX.Element | string;
  sortDirection?: SortDirection;
  className?: string;
}

export default function Cell({
  children,
  sortDirection,
  className,
}: CellProps): React.JSX.Element {
  return (
    <TableCell
      align="left"
      padding="none"
      sortDirection={sortDirection}
      className={className}
      classes={{
        root: `${classNameBase}-root`,
        head: `${classNameBase}-head`,
      }}
    >
      {children}
    </TableCell>
  );
}
